var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultFavouriteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8365 32 16C32 7.16345 24.8366 0 16 0C7.16345 0 0 7.16345 0 16C0 24.8365 7.16345 32 16 32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0621 5.65925L19.5435 10.6776C19.716 11.0267 20.0496 11.2685 20.4356 11.3244L25.9842 12.1292C26.9562 12.2703 27.344 13.4621 26.6409 14.146L22.6259 18.0522C22.3469 18.3239 22.2194 18.7155 22.2854 19.0989L23.2331 24.6147C23.3992 25.5807 22.3832 26.3173 21.514 25.8615L16.5514 23.2575C16.2063 23.0766 15.7937 23.0766 15.4486 23.2575L10.486 25.8615C9.61679 26.3177 8.60077 25.5807 8.76689 24.6147L9.71454 19.0989C9.78062 18.7155 9.65305 18.3239 9.37403 18.0522L5.35903 14.146C4.65598 13.4617 5.04376 12.2698 6.01573 12.1292L11.5644 11.3244C11.9503 11.2685 12.284 11.0267 12.4565 10.6776L14.9378 5.65925C15.372 4.78025 16.6275 4.78025 17.0621 5.65925Z",
    fill: "#9747FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFavouriteIcon);
export default __webpack_public_path__ + "static/media/DefaultFavouriteIcon.f0528118e2434fd161283cd8ce74b6d6.svg";
export { ForwardRef as ReactComponent };